module.exports = __webpack_public_path__ + "media/images/logo/logo-giuliani-white-90cddbdaabc70d1b24db525c76d6946d.svg";